import { useMemo } from "react";
import { useSelector } from "react-redux";
import algoliaIndices from "@utils/constants/algoliaIndices";

const { mainIndexV1, mainIndexV2 } = algoliaIndices;

const useFeatures = () => {
  return useSelector((state) => state.features);
};

export const useDeliveryCountries = () => {
  const carriersSpecs = useSelector((state) => state.features.carriers_specificities);

  return carriersSpecs.map((country) => country.iso_3166).sort();
};

export const useFiltersList = () => {
  return useSelector((state) => state.features?.filters_list);
};

export const useReferralProgram = () => {
  return useSelector((state) => state.features?.referral_program);
};

export const useCatalogVersion = () => {
  const customerFeatureCatalogVersion = useSelector((state) => state.features?.catalog_version);
  const isUserCatalogV2Tester = useSelector((state) => state.user?.currentUser?.catalog_v2_tester);

  return isUserCatalogV2Tester ? 2 : customerFeatureCatalogVersion;
};

export const useMainIndex = () => {
  const catalogVersion = useCatalogVersion();

  return useMemo(() => (catalogVersion === 1 ? mainIndexV1 : mainIndexV2), [catalogVersion]);
};

export default useFeatures;
